import { render, staticRenderFns } from "./FourthStepAssistance.vue?vue&type=template&id=7b74e045&"
import script from "./FourthStepAssistance.vue?vue&type=script&lang=js&"
export * from "./FourthStepAssistance.vue?vue&type=script&lang=js&"
import style0 from "./FourthStepAssistance.vue?vue&type=style&index=0&id=7b74e045&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports